import React from 'react';

import OtherInfoModal from 'ff/debrief/components/modals/OtherInfoModal';
import DownloadsModal from 'ff/debrief/components/modals/DownloadsModal';
import DeleteTracklogModal from 'ff/debrief/components/modals/DeleteTracklogModal';
import ShareModal from 'ff/debrief/components/modals/ShareModal';
import VspeedModal from 'ff/debrief/components/modals/VspeedModal';
import LinkLogbookModal from 'ff/debrief/components/modals/LinkLogbookModal';
import ImportsModal from 'ff/debrief/components/modals/ImportsModal';
import RemoveShareModal from 'ff/debrief/components/modals/RemoveShareModal';

const ModalManager = () => {
    return (
        <>
            <LinkLogbookModal />
            <OtherInfoModal />
            <DownloadsModal />
            <VspeedModal />
            <DeleteTracklogModal />
            <ShareModal />
            <RemoveShareModal />
            <ImportsModal />
        </>
    );
};

export default ModalManager;
